"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Sort a list of LayoutShift entries by `LSValues` in descending order */
const prepCLSEntries = (entries = []) => [...entries].sort((a, b) => b.LSValue - a.LSValue);
exports.default = prepCLSEntries;
